import type { ICopilotExternalQueryConfig } from '@/pages/aigc/pages/Agent/Copilot/hooks/useCopilotOpenBridge';

/** 报告相对路径中 rule_key 的提取正则：/as/report/<rule_key>/xxx.html */
export const REPORT_RULE_KEY_REGEX = /^\/as\/report\/([^/]+)/;

/**
 * 构造「AI 编辑 HTML 报告」的 Copilot 外部引用配置（ReportToolbar 与 AIGalleryHome 共用）
 *
 * 传给后端的报告链接统一走 AI Gallery Report 嵌入页路由：
 * 当前域名 + /aigallery/report + 编码后的 path / name，便于后端识别报告归属。
 * DIY skill 不在此处携带：由 submitHelpers 按 form=aigallery_report 默认追加 specified_skills。
 * @param options - 构造参数
 * @param options.path - 报告相对路径（/as/report/...）
 * @param options.pageName - 报告页面名（URL query name，作为 Copilot 引用来源的文件标签）
 * @param options.title - 报告标题（pageName 缺失时的降级标签）
 * @param options.query - 已按当前语言格式化的默认提示语
 * @returns Copilot 外部引用配置（含 quoted_content，value 为当前报告链接）；path 为空时返回 null
 */
export const buildAIGalleryReportEditConfig = (options: {
  path: string;
  pageName: string;
  title: string;
  query: string;
}): ICopilotExternalQueryConfig | null => {
  const { path, pageName, title, query } = options;
  if (!path) return null;

  const prefixTag = pageName || title;
  const reportUrl = `${window.location.origin}/aigallery/report?path=${encodeURIComponent(
    path,
  )}&name=${encodeURIComponent(prefixTag)}`;

  return {
    prefixTag,
    query,
    form: 'aigallery_report',
    // 引用内容标识：value 覆盖默认的 prefixTag，透传当前报告链接供后端识别（getQuotedContent 会在提交时刻注入）
    quoted_content: {
      type: 'game',
      value: reportUrl,
    },
    files: [
      {
        type: 'file',
        file: { mimeType: 'document', uri: reportUrl },
      },
    ],
  };
};
